import React from 'react';

export type TabKey = 'edit' | 'ai' | 'library';

interface TabNavigationProps {
  active: TabKey;
  onSelect(tab: TabKey): void;
  hideLibrary?: boolean;
}

const TABS: { key: TabKey; label: string }[] = [
  { key: 'edit', label: 'EDIT' },
  { key: 'ai', label: 'AI' },
  { key: 'library', label: 'LIBRARY' },
];

const TabNavigation: React.FC<TabNavigationProps> = ({ active, onSelect, hideLibrary = false }) => {
  const visibleTabs = hideLibrary ? TABS.filter(t => t.key !== 'library') : TABS;
  return (
    <div className="tab-bar">
      {visibleTabs.map(t => {
        const isActive = t.key === active;
        return (
          <button
            key={t.key}
            className="tab-btn"
            data-active={isActive ? 'true' : 'false'}
            onClick={() => onSelect(t.key)}
            type="button"
          >
            <span className="tab-label">{t.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default TabNavigation;